import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../services/api';
import AuthCard from './AuthCard';
import styles from './auth.module.css';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('invalid');
      return;
    }

    authAPI.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <Container component="main" maxWidth="xs">
      <Box className={styles.wrap}>
        <AuthCard>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            {t('auth.verifyEmail.title')}
          </Typography>

          {status === 'loading' && (
            <Box className={styles.spinnerBox}>
              <CircularProgress />
            </Box>
          )}

          {status === 'success' && (
            <Alert severity="success" className={styles.alert}>
              {t('auth.verifyEmail.success')}
            </Alert>
          )}

          {(status === 'error' || status === 'invalid') && (
            <Alert severity="error" className={styles.alert}>
              {status === 'invalid'
                ? t('auth.verifyEmail.missingToken')
                : t('auth.verifyEmail.invalidLink')}
            </Alert>
          )}

          {status !== 'loading' && (
            <Box className={`${styles.linkRowCenter} ${styles.mt3}`}>
              <Link to="/login" className={styles.link}>
                <Typography variant="body2" color="primary">
                  {t('auth.goToSignIn')}
                </Typography>
              </Link>
            </Box>
          )}
        </AuthCard>
      </Box>
    </Container>
  );
};

export default VerifyEmail;
